module.exports = __webpack_public_path__ + "static/media/screen2.78e96043.png";